const IMAGE_BASE_PATH_PC = 'home/pc/';

const section1 = {
  title:
    'Get started with CIETY,\n' + 'the community platform\n' + 'for Creators!',
  desc: 'Community Platform for Creators\n' + 'Your World, Your CIETY',
  buttonLabel: 'Create CIETY',
  buttonLabelM: 'Create Community',
  toolTip:
    'Create a CIETY subdomain and\n' + 'build your community right away!',
};

const section2 = {
  title:
    'From newbies to true fans!\n' +
    'A world of fun moments that\n' +
    'naturally deepen connections',
};

const section3 = {
  subTitle: "Let's start a community!",
  title:
    'Starting a community means\n' +
    'gathering your true fans and\n' +
    'being able to connect with them!',
  titleM:
    'Creating a community\n' + 'means connecting\n' + 'with your true fans!',
  desc:
    'Are you still communicating with your fandom through short comments? \n' +
    'Fill your community with various interaction methods, and create content\n' +
    "or products that reflect your fans' needs and ideas!",
  descM:
    'Comments still your only form of fan interaction?\n' +
    "Let's diversify and create content and products that\n" +
    "resonate with the fandom's needs!",
  buttonLabel: 'Get started for free',
};

const section4 = {
  subTitle: 'Hello. Creator',
  title: 'Perfect community\n' + 'for Creators!',
  desc:
    'From simple channel updates to open discussions, paid content sales,\n' +
    'and merchandise sales — what if you had a space to talk with membership?\n' +
    'Gather the fans who are steamed in CIETY!',
  descM:
    'Gather your true fans on your community\n' +
    'with announcements, casual chats, paid content,\n' +
    'and merchandise sales!',
  buttonLabel: 'Get started for free',
  messages: [
    [
      'Loved the game \n' + 'ou recommended!!!',
      'Live at 7 PM!\n' + 'Join me on CIETY!',
      'Anyone know what time\n' + "today's livestream is?",
      'Excited for your quick\n' + 'review of the new game!',
      'Limited edition goods...\n' + 'Not for resale???...',
    ],
    [
      "Today's live outfit\n" + 'is totally my style!',
      'Gloves and hats\n' + 'merch, please!!!!!!',
      'Live now! Check out\n' + 'our summer t-shirt haul!',
      "Curious about today's makeup!\n" + 'Eyeshadow product details plz.',
      'Community t-shirts merch rocks!\n' + 'Off to buy it now!',
    ],
    [
      'Love the soothing voice,\n' + "it's so calming...",
      'Livestream is the real deal...\n' + 'Ears are melting!',
      'Please open a concert! \n' + "I'll definitely buy tickets..!!",
      "Until when's the live today?\n" + 'Inviting all my friends!!',
      'Song request event happening now.\n' +
        "I'll sing for you and send merch!",
    ],
  ],
  messagesM: [
    [
      'Anyone know what time\n' + "today's livestream is?",
      'Live at 7 PM!\n' + 'Join me on CIETY!',
      'Limited edition goods...\n' + 'Not for resale???...',
    ],
    [
      "Today's live outfit\n" + 'is totally my style!',
      'Live now! Check out\n' + 'our summer t-shirt haul!',
      'Community t-shirts\n' + 'merch rocks!\n' + 'Off to buy it now!',
    ],
    [
      'Livestream is the real deal...\n' + 'Ears are melting!',
      'Please open a concert! \n' + "I'll definitely buy tickets..!!",
      'Song request event now.\n' + "I'll sing for you & send merch!",
    ],
  ],
  images: [
    `${IMAGE_BASE_PATH_PC}EN-Section6-img1.png`,
    `${IMAGE_BASE_PATH_PC}EN-Section6-img2.png`,
    `${IMAGE_BASE_PATH_PC}EN-Section6-img3.png`,
  ],
};

const section5 = {
  subTitle: 'for your Real Fandom',
  title:
    'Create a membership-only channel\n' +
    'that only my membership group can see!',
  titleM: 'Membership-only channel that\n' + 'only membership group can see!',
  desc:
    'CIETY can set channel participation conditions.\n' +
    'Of course, open channels that anyone can participate in are also available!',
  descM:
    'Set membership criteria via MappleShop account linking\n' +
    'or create an open community for all!',
  buttonLabel: 'Get started for free',
  imageLabels: ['Non-Member', 'Member', 'Membership', 'Power Membership'],
};

const section6 = {
  subTitle: 'from creator to Brand Growth',
  title:
    'From identifying subscriber\n' +
    'needs in my community\n' +
    'to producing and selling merch!',
  titleM: 'needs of fandom,\n' + 'from making goods to selling!',
  desc:
    'In the diverse range of stories freely shared on CIETY,\n' +
    'you can discover various needs of subscribers.\n' +
    'Get insights from subscriber needs to plan and launch merchandise!\n' +
    'From production to sales and shipping, everything is possible on CIETY!',
  descM:
    'Get insights from fandom needs to plan and sell goods.\n' +
    'Everything is possible from making goods\n' +
    'to selling and shipping!',
  buttonLabel: 'Get started for free',
};

const section7 = {
  subTitle: 'Exclusive Live Streaming',
  title:
    'Exclusive live streaming\n' +
    'only for the community\n' +
    'members I desire!',
  titleM:
    'Exclusive live streaming\n' +
    'available only for\n' +
    'community members!',
  desc:
    'On CIETY, you can broadcast live streams exclusively for\n' +
    'community membership subscribers or specific members!\n' +
    'Connect more closely with your community members!',
  descM:
    'For community membership members\n' +
    'You can stream it live to certain members!',
  buttonLabel: 'Get started for free',
  messages: [
    'So nice.........',
    'Hearing this song\n' + 'live is so moving...\n',
    "This isn't on the album!!!",
    'Wow, seeing this on CIETY!',
    'waiting for this song!!!!!!',
    "Today's awesome!",
    "Got the tee, it's beautiful!",
    "Live's the best!",
    "You're amazing...",
  ],
};

const section8 = {
  subTitle: 'Contents Commerce in Community',
  title: 'From high-quality paid content\n' + 'to selling online classes!',
  titleM: 'Sell high-quality\n' + 'paid content and classes!',
  desc:
    'Communicate with subscribers who like you and are interested.\n' +
    'It produces high-quality content and easily sells online classes.\n' +
    "It's easy when linked to the MappleShop membership plan!",
  descM:
    'Create content and sell online classes.\n' +
    "It's easy when linked\n" +
    'to the Maple Shop membership plan!',
  buttonLabel: 'Get started for free',
};

const section9 = {
  subTitle: 'Direct Message',
  title:
    'Gift your fans a\n' +
    'deeper sense of belonging\n' +
    'with 1:1 direct messaging!',
  titleM:
    'Gift your fans with a deeper\n' +
    'sense of belonging through\n' +
    '1:1 direct messaging!',
  desc:
    'If members can freely chat with the creators and other members\n' +
    'they want to converse with within the community,\n' +
    'the cohesion of the community will strengthen even more!\n' +
    'You can give message permissions to certain groups and communicate with them.',
  descM:
    'Open communication fosters\n' +
    'stronger community bonds! Direct messaging\n' +
    'with members or the creator is essential!',
  buttonLabel: 'Get started for free',
};

const section10 = {
  subTitle: 'Community Member Permission',
  title:
    'Unlimited group creation\n' +
    'and flexible member\n' +
    'permissions in my community!',
  titleM:
    'Create unlimited member\n' +
    'groups with flexible\n' +
    'permission settings!',
  desc:
    'You can manage the community in various groups based on distinctions\n' +
    'like non-subscribers, subscribers, and YouTube channel memberships, \n' +
    'allowing for more detailed management by combining member groups as desired. \n' +
    'Additionally, you can set different permission levels for each group,\n' +
    'enabling special interactions!',
  descM:
    'Special communication and management are\n' +
    'possible through various settings\n' +
    'for non-members, members, and membership groups!',
  buttonLabel: 'Get started for free',
  circleTaps: ['Non-Member', 'Member', 'Membership', 'Power-Membership'],
  circleTapsM: ['Non-Mem', 'Member', 'Membership', 'Power-Mem'],
  checkList: [
    'Read, Write Posts',
    'Comments, Emojis',
    'Access to Paid Contents',
    'Access to Limited Merch',
    'Direct Message',
    'View Member List',
    'Livestream',
    'Manager Permissions',
  ],
};

const section11 = {
  title: 'The community you need,\n' + 'Start now with CIETY!',
  titleM: 'The community you need,\n' + 'Start now with CIETY!',
  desc: 'Community Platform for Creators\n' + 'Your World, Your CIETY',
  buttonLabel: 'Create CIETY',
  cards: [
    {
      title: 'Community\n' + 'Design Custom',
      desc:
        'It expresses creator branding\n' +
        'with community covers and profiles, etc.',
    },
    {
      title: 'Open/private community settings',
      desc:
        'Only members can join and manage\n' +
        'it as a membership-exclusive community',
    },
    {
      title: 'MarppleShop Product Sales\n' + 'Community Shop',
      desc:
        'Expose MarpleShop merchandise as it is\n' +
        'in the community and sell it at the MarpleShop!',
    },
    {
      title: 'Membership-only live stream',
      desc:
        'We only communicate in real time on CIETY,\n' +
        'not on other streaming platforms',
    },
    {
      title: 'Paid Content\n' + 'Membership Only Content',
      desc:
        'Increase fan loyalty with content that can\n' +
        'only be viewed by membership members',
    },
    {
      title: 'free communication',
      desc:
        'It supports all the functions you need to communicate\n' +
        'With fans, messages, images, videos, emoticons, etc',
    },
    {
      title: '1:1 message, group chat',
      desc:
        "I'll share my news in various ways and communicate\n" +
        'actively through comments and emoticons',
    },
    {
      title: 'Setting Member\n' + 'Group Permissions',
      desc:
        'I give various authority to each group\n' +
        'and communicate with community members',
    },
  ],
};

const section12 = {
  title: 'CIETY, a community\n' + 'platform like no other',
  desc: 'CIETY continuously enhances its features to support a wide range of creators.',
  descM:
    'CIETY continuously enhances its\n' +
    'features to support a wide range of creators.',
};

const section13 = {
  title: 'With CIETY\n' + 'Anytime, Anywhere!',
  desc: 'Community Platform for Creators\n' + 'Your World, Your CIETY',
  ios: { title: 'iOS', label: 'App Store Download' },
  android: { title: 'Android', label: 'Google Play Download' },
  browser: { title: 'Web Browser', label: 'Open at Web Browser' },
  deskApp: { title: 'Desk App', label: 'Over MacOS 10.13 (High Sierra)' },
  buttonLabel: 'Create CIETY',
};

const membership = {
  title:
    'The Community And\n' +
    'If You Link the MarppleShop,\n' +
    'You Can Run A membership!',
  desc:
    'You can sell your membership at the MarppleShop \n' +
    'and offer community benefits at CIETY.\n' +
    'Create a community that communicates more deeply\n' +
    'with the benefits of content, live broadcasts, 1:1 messages!',
  descM:
    'You can sell your membership at the MarppleShop \n' +
    'and offer community benefits at CIETY.\n' +
    'Create a community that communicates more deeply\n' +
    'with content, live broadcasts, 1:1 messages!',
  buttonLabel: 'Get started for free',
};

export default {
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
  section11,
  section12,
  section13,
  membership,
};
